export class KYCRandomSecQuesAnsOption {
  public kyccbSecQuestionId: number;
  public questionId: number;
  public answerOptionId: number;
  public answerOptionValue: string;
  public selected: string;

}
